import { render } from "./SalesReturnReport.vue?vue&type=template&id=50f89e99&scoped=true&ts=true"
import script from "./SalesReturnReport.vue?vue&type=script&lang=ts"
export * from "./SalesReturnReport.vue?vue&type=script&lang=ts"

import "./SalesReturnReport.vue?vue&type=style&index=0&id=50f89e99&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f89e99"]])

export default __exports__